<!-- WCAG 2.4.1 (Bypass Blocks), level A. Every route mounts a sidenav whose items come before the
     content in the tab order, so a keyboard user tabbed the whole menu again on every navigation.
     It lives HERE, at the root, rather than in a shell: there are four routed shells and CLAUDE.md
     records what happens to anything added to only some of them (the push-status icon shipped into
     one and was invisible on the two busiest areas). One link at the root covers all four, and the
     TARGET is what each shell has to declare -- swept by a served-template guard so a fifth shell
     cannot silently arrive without one.
     The (click) is load-bearing: <base href="/"> resolves the bare fragment against "/", so without
     it the link reloads the app at /#main-content instead of moving focus. It renders only on /app
     routes, the only ones that mount a shell and so the only ones with a target. -->
<a *ngIf="showSkipLink" class="skip-link" href="#main-content" (click)="skipToContent($event)">{{ 'common.a11y.skipToContent' | translate }}</a>

<app-update-banner></app-update-banner>

<nav *ngIf="nameProd" class="navbar navbar-expand-lg fixed-bottom bg-dark " style="margin: 0 50px;">
  <div class="container-fluid justify-content-between ">
    <div class="d-flex">
      <span  style="color: var(--g15-on-surface); font-size: 1.25rem;">
        {{nameProd}}
      </span>
    </div>

    <div class="d-flex">
      <!-- A real button (WCAG 2.1.1/4.1.2, audit:pointeronly); the visible "X" names nothing. -->
      <button type="button" class="g15-bare-button sn" (click)="nameProd = undefined"
        [attr.aria-label]="'common.actions.close' | translate"><span aria-hidden="true">X</span></button>
    </div>
  </div>
</nav>

<router-outlet></router-outlet>
